<template>
  <Loading v-if="!pageLoad"></Loading>
  <MasterLayout v-if="pageLoad" page_title="افزودن برند محصول">
    <Card>
        <button type="button" @click="join">Join</button>
        <button type="button" @click="test">Test</button>
      <strong>{{c}}</strong>
    </Card>

  </MasterLayout>
</template>

<script>
import vSelect from 'vue-select'
import MasterLayout from "@/components/MasterLayout";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
import Loading from "@/components/Loading";
import { io } from "socket.io-client";
import {mapGetters} from "vuex";
import {sleep} from "@/shared/helper";
import Card from "@/components/forms/Card";
import {AppApi} from "@/api/AppApi";

export default {
  name: "AddProductBrand",
  components: {Card, Loading, AjaxForm, CustomInput, MasterLayout,vSelect},
  data(){
    return {
      pageLoad : true,
      socket:null,
      c:0
    }
  },
  async mounted()
  {
    this.initPage();
    await sleep(1000);
    this.getSocket.on('run_p',async (data)=>{
      console.log('running: ',data)
      this.c++;
    })
  },
  methods : {
    async join()
    {
      if (!this.socket)
      {
        const socket = io("ws://127.0.0.1:3333", {
          reconnectionDelayMax: 10000,
          extraHeaders: {
            authorization: 'bearer ' + this.userData.token
          }
        });
        this.socket = socket;
        this.socket.io.on('open',()=>{
          console.log('socket opened1')
        })
      }

      this.socket.on('message', function (data) {
        console.log('received message: ',data)
      });
      this.socket.emit('join',{title:'test',content:'ok'});

      this.socket.on('newItem',async (data)=>{
        console.log('received something: ',data)
        this.c++;
      })

    },
    async test()
    {
      this.socket.emit('test');
    },
    initPage()
    {
      this.pageLoad = false;
      this.pageLoad = true;
    }
  },
  computed:{
    ...mapGetters('auth',{
      userData:'getAuthData'
    }),
    ...mapGetters('socket',{
      getSocket:'getSocket'
    })
  }

}
</script>

<style scoped>

</style>
